/* eslint-disable @nx/enforce-module-boundaries */
import { Heading } from '@mybridge/ui';
import { forwardRef, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { SupportIndex } from 'v4/snippets/support';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';

const SupportPage = forwardRef(({ ...props }, ref) => {
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const hasTrackedPageVisit = useRef(false);

  const getUserSlug = () => {
    return userProfileInfo?.slug;
  };

  const trackSupportPageVisit = () => {
    const userSlug = getUserSlug();
    if (!userSlug) return;

    trackEvent(ANALYTICS_EVENTS.HelpSupport, userSlug, {
      page_path: '/support',
      page_title: 'Help & Support',
      timestamp: new Date().toISOString()
    });
  };

  useEffect(() => {
    const userSlug = getUserSlug();
    if (userSlug && !hasTrackedPageVisit.current) {
      trackSupportPageVisit();
      hasTrackedPageVisit.current = true;
    }
  }, [userProfileInfo]);

  return (
    <>
      <SupportIndex />
    </>
  );
});

export default SupportPage;
